import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select', 'explanation', 'textarea']
  static values = { triggerValue: String }

  connect() {
    this.toggleExplanation()
  }

  toggle() {
    this.toggleExplanation()
  }

  toggleExplanation() {
    let selectedValue = null

    // Handle select elements
    if (this.hasSelectTarget) {
      selectedValue = this.selectTarget.value
    } else {
      // Handle radio buttons - find the checked radio button within this controller's scope
      const checkedRadio = this.element.querySelector(
        'input[type="radio"]:checked'
      )
      if (checkedRadio) {
        selectedValue = checkedRadio.value
      }
    }

    // Support multiple trigger values (comma-separated string or array)
    let triggerValues = []
    if (this.hasTriggerValueValue) {
      if (Array.isArray(this.triggerValueValue)) {
        triggerValues = this.triggerValueValue
      } else if (
        typeof this.triggerValueValue === 'string' &&
        this.triggerValueValue.includes(',')
      ) {
        triggerValues = this.triggerValueValue.split(',').map((v) => v.trim())
      } else {
        triggerValues = [this.triggerValueValue]
      }
    }

    const shouldShow = triggerValues.includes(selectedValue)

    if (shouldShow) {
      this.explanationTarget.classList.remove('hidden')
      if (this.hasTextareaTarget) {
        this.textareaTarget.setAttribute('required', 'required')
      }
    } else {
      this.explanationTarget.classList.add('hidden')
      if (this.hasTextareaTarget) {
        this.textareaTarget.removeAttribute('required')
        this.textareaTarget.value = ''
      }
    }
  }
}
